import { PatientGroup } from '@dreryk/egabinet-patient-frontend-api';

import { CustomPatientGroupsUpdateFormBean } from './CustomPatientGroupsUpdateForm.types';

export const customPatientGroupsUpdateFormInitializer = (
   patientGroup: PatientGroup
) => (): CustomPatientGroupsUpdateFormBean => ({
   name: patientGroup.name,
   primaryColor: patientGroup.primaryColor.asHexString(),
});
